module.exports = __webpack_public_path__ + "img/crystals-logo.330dcad9.svg";